import React, { useState, useEffect } from 'react';
// Styles
import {
    Card,
    Title,
    Label,
    Logo,
} from './style';


const CampaignObjectiveRadio = ({
    logo,
    title,
    label,
    actualObjective,
    objectiveId,
    setObjective,
    id,
}) => {
    const SVG = logo;
    const [isSelected, setIsSelected] = useState(false);
    useEffect(() => {
        setIsSelected(actualObjective === objectiveId);
    }, [actualObjective]);
    return (
	<Card id={id} className={isSelected ? 'isSelected' : ''} onClick={() => setObjective(objectiveId)}>
		<Logo className={isSelected ? 'isSelected' : ''} component={<SVG />} />
		<Title>{title}</Title>
		<Label>{label}</Label>
	</Card>
    );
};

export default CampaignObjectiveRadio;
